import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
    return (
        <footer className="footer-root">
            <div className="wrap" style={{ padding: 0 }}>


                <div className="footer-bottom">
                    <span>© 2026 Global Inavation. All rights reserved.</span>

                </div>
            </div>
        </footer>
    );
}